
const bootstrap = window.bootstrap;

enum ModalSize {
    SM = 'sm',
    LG = 'lg',
    XL = 'xl'
}

let modalCount: number = 0;

class Modal {
	static show(title: string, content: string | HTMLElement, size: string, width: number = 0, height: number = 0, backdrop: boolean = false): bootstrap.Modal {
        title = title ?? '';
        let dialogClass = 'modal-dialog modal-dialog-scrollable';
        if(size && size != '') {
            dialogClass += ' modal-' + size;
        }

        modalCount++;

        const modalId = 'th_modal_' + modalCount.toString();

        let modalEl: HTMLElement = document.createElement('div');
        modalEl.setAttribute('role', 'dialog');
        modalEl.classList.add('modal', 'fade');
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.setAttribute('aria-labelledby', modalId + '_modal_title');
        modalEl.innerHTML = `
            <div class="${dialogClass}">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title" id="${modalId}_modal_title">${title}</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-body-content d-flex justify-content-center">
                        </div>
                    </div>
                </div>
            </div>
        `;

        const modalBodyEl: HTMLElement = modalEl.querySelector('.modal-body') as HTMLElement;
        if(width > 0) {
            modalBodyEl.style.width = width + 'px';
        }
        if(height > 0) {
            modalBodyEl.style.height = height + 'px';
        }
        const modalBodyContentEl: HTMLElement = modalEl.querySelector('.modal-body-content') as HTMLElement;
        modalBodyContentEl.append(content);

        document.querySelector('body')!.appendChild(modalEl);
        const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
            backdrop: backdrop,
            keyboard: true
        });
        if(modalEl.querySelector<HTMLElement>('button.close')) {
            modalEl.querySelector<HTMLElement>('button.close')!.addEventListener('click', (ev: MouseEvent) => {
                modal.toggle(ev.relatedTarget as HTMLElement);
            });
        }

        modal.show();

        return modal;
	}
}

export { ModalSize };
export default Modal;

